// Static data mirrored from backend profile_data.py (kept in sync manually).
export const PROFILE = {
  name: "Shivmurat Gupta",
  short: "Shiv",
  titles: ["Software Developer", "Python Developer", "AI & Cloud Enthusiast"],
  years_experience: "4+",
  location: "Lucknow, India",
  email: "officialshiv6@gmail.com",
  phone: "+91 81049 40567",
  whatsapp: "https://wa.me/918104940567",
  linkedin: "https://www.linkedin.com/in/shivmuratg",
  github: "https://github.com/galaxeeranger",
  resume_url: "/Shivmurat_Gupta_Resume.pdf",
  source_site: "https://shivmuratgupta.com/",
  summary:
    "Results-driven Software Developer with 4+ years of professional experience designing, developing and deploying robust applications. Expertise in Python, Django, REST APIs, AWS Cloud and AI-driven solutions using OpenAI & Machine Learning.",
  skills: {
    "Programming Languages": ["Python", "JavaScript", "SQL", "HTML5", "CSS3", "Bash", "Rust"],
    "Backend Frameworks": ["Django", "Django REST Framework", "FastAPI", "Flask", "Celery", "Streamlit", "Selenium"],
    "Machine Learning": ["TensorFlow", "PyTorch", "Scikit-Learn", "Deep Learning", "Computer Vision", "NLP", "Time Series Forecasting"],
    "LLM & AI Engineering": ["OpenAI API", "LangChain", "Hugging Face", "RAG", "AI Agents", "Ollama", "Prompt Engineering", "Vector Databases", "ChromaDB"],
    "Developer Tools": ["GitHub Actions", "Linux", "VS Code", "OpenCode", "Aider", "OpenClaw"],
    "Databases & Caching": ["PostgreSQL", "MySQL", "MongoDB", "SQLite", "Redis", "FAISS (Vector DB)", "ChromaDB (Vector DB)"],
    "Cloud & DevOps": ["AWS EC2", "AWS S3", "AWS RDS", "Docker", "Nginx", "Gunicorn", "CI/CD"],
    "Security & Auth": ["JWT", "OAuth 2.0", "Role-Based Access Control", "API Rate Limiting", "Data Validation"],
    "Architecture & Tooling": ["RESTful APIs", "Microservices", "System Design", "Performance Optimization", "WebAssembly (WASM)", "Git & GitHub"],
  },
  certifications: [
    {
      title: "ChatGPT Prompt Engineering for Developers",
      issuer: "DeepLearning.AI",
      year: "2024",
      note: "Course by Isa Fulford & Andrew Ng on prompt design, system messages and AI-assisted workflows.",
    },
    {
      title: "Problem Solving (Basic)",
      issuer: "HackerRank",
      year: "2021",
      note: "Certified Python problem solver — strong analytical & algorithmic thinking.",
    },
    {
      title: "Python Django Development",
      issuer: "LearnVern · NSDC Certified",
      year: "2021",
      note: "Government-recognized certification on Django, backend APIs and database integration.",
    },
  ],
  projects: [
    {
      id: "shopright",
      name: "ShopRight - Food Detection System",
      url: "https://shopright.ai",
      tag: "AI Food Detection System",
      icon: "🍱",
      desc: "Enterprise food detection platform with client onboarding portal. YOLO-based system identifies bakery and prepared food items in real time for smart retail automation and canteen monitoring.",
      highlights: [
        "Tech: Custom YOLO model (Roboflow dataset) + Django backend + FastAPI inference + AWS EC2/S3",
        "Enhancement: Added multi-tenant onboarding portal → reduced client onboarding time by 60%",
        "Enhancement: Optimized inference pipeline with auto-scaling → cut AWS EC2 costs by ~35%",
        "Enhancement: Improved inventory accuracy from 65% to 80%, reducing food waste and stockouts",
      ],
      stack: ["Python", "YOLO", "Roboflow", "Django", "FastAPI", "AWS EC2", "AWS S3"],
      span: "wide",
    },
    {
      id: "nutrition-ocr",
      name: "Nutrition Extractor OCR - Nutrianalyser",
      tag: "Computer Vision + OCR",
      icon: "📦",
      url: "https://github.com/galaxeeranger/Nutrition-Extractor-OCR",
      desc: "AI-powered OCR pipeline that reads nutritional labels from food packaging images and converts unstructured text into validated, machine-readable JSON.",
      highlights: [
        "Tech: OpenCV preprocessing + Tesseract OCR + custom validation layer → structured JSON output",
        "Enhancement: Added adaptive image enhancement → text extraction accuracy improved from 75% to 94%",
        "Enhancement: Multi-stage validation pipeline → reduced OCR false positives by 40%",
        "Enhancement: Optimized preprocessing → 40% faster processing per image",
      ],
      stack: ["Python", "OpenCV", "Tesseract OCR", "NumPy", "Pillow", "JSON"],
      span: "wide",
    },
    {
      id: "dicom",
      name: "Dicom Viewer",
      url: "https://github.com/galaxeeranger/Dicom-Visualizer",
      tag: "Medical Imaging Platform",
      icon: "🩺",
      desc: "Desktop medical imaging platform for radiologists — supports CT and MRI DICOM files with multi-plane visualization, 3D volume rendering and AI-powered organ segmentation.",
      highlights: [
        "Tech: PyDICOM + VTK/OpenGL 3D rendering + TotalSegmentator AI segmentation",
        "Enhancement: GPU-accelerated volume rendering → reduced 3D visualization latency by 50%",
        "Enhancement: Fine-tuned TotalSegmentator → improved organ boundary detection by 30%",
        "Enhancement: Added measurement tools → reduced radiologist annotation time by 25% per study",
      ],
      stack: ["Python", "PyQt6", "PyDICOM", "VTK", "OpenGL", "SimpleITK", "TotalSegmentator"],
      span: "tall",
    },
    {
      id: "mocap",
      name: "Motion Capture (Mocap)",
      url: "https://github.com/galaxeeranger/Body-Motion-Tracking",
      tag: "AI Motion Capture",
      icon: "🧍",
      desc: "Real-time AI motion capture system that converts human body movement from video or webcam feeds into 3D animated FBX characters ready for game and animation pipelines.",
      highlights: [
        "Tech: MediaPipe Holistic + OpenPose + multi-camera fusion + FBX SDK export",
        "Enhancement: Multi-camera skeletal fusion → reduced joint tracking error by 25%",
        "Enhancement: Optimized FBX export pipeline → 4x faster export for 30-second motion clips",
        "Enhancement: Added PyQt6 recording/playback GUI → streamlined animator workflow",
      ],
      stack: ["Python", "MediaPipe", "OpenPose", "OpenCV", "PyQt6", "FBX SDK"],
    },
    {
      id: "exercise",
      name: "AI Exercise Tracker",
      url: "https://nutrianalyser.com/",
      tag: "Browser Pose Detection",
      icon: "🏋️",
      desc: "Dual-platform exercise coach that tracks posture and counts reps in real time — runs as a Python desktop app and as a fully client-side browser app compiled to WebAssembly.",
      highlights: [
        "Tech: MediaPipe Holistic + Rust/WASM core + PyQt6 desktop + browser frontend",
        "Enhancement: WASM real-time smoothing → reduced rep counting error from 15% to 5%",
        "Enhancement: Single Rust core reused across platforms → saved 60% development cost",
        "Enhancement: Client-side browser execution → $0 backend hosting costs",
      ],
      stack: ["Python", "MediaPipe", "OpenCV", "Rust", "WebAssembly", "PyQt6"],
    },
    {
      id: "voicebot",
      name: "Voice Chatbot Assistant",
      url: "https://github.com/galaxeeranger/Voice-Chatbot",
      tag: "Multipurpose AI Assistant",
      icon: "🎤",
      desc: "Voice-first conversational AI assistant supporting Q&A, entertainment, news, music and automation commands — fully driven by speech recognition and LLM-powered NLP pipelines.",
      highlights: [
        "Tech: SpeechRecognition STT + OpenAI GPT + pyttsx3 TTS + LangChain orchestration",
        "Enhancement: Streaming STT+LLM pipeline → cut response latency from 2.5s to 1.2s",
        "Enhancement: GPT-3.5-turbo fine-tuning on command patterns → reduced API costs by 30%",
        "Enhancement: Added multi-turn conversation memory → improved contextual accuracy by 45%",
      ],
      stack: ["Python", "OpenAI API", "SpeechRecognition", "pyttsx3", "LangChain", "REST APIs"],
    },
    {
      id: "fin-ai",
      name: "Financial AI Chatbot",
      url: "https://finchatbot-ui.devtrust.biz/",
      tag: "Markets & Insights",
      icon: "💰",
      desc: "AI-powered financial assistant that delivers real-time market insights, stock predictions and portfolio analysis across equities, crypto and forex using LLM and financial APIs.",
      highlights: [
        "Tech: OpenAI GPT + live financial APIs (stocks/crypto/forex) + ARIMA forecasting + Django REST",
        "Enhancement: Integrated ARIMA with live APIs → prediction latency reduced by 60% vs batch mode",
        "Enhancement: Added API rate limiting & caching → cut monthly OpenAI costs by 45%",
        "Enhancement: Modular financial provider integrations → 70% faster addition of new data sources",
      ],
      stack: ["Python", "OpenAI API", "Django", "Django REST Framework", "ARIMA", "JWT", "PostgreSQL"],
      span: "wide",
    },
    {
      id: "bhaarat",
      name: "BhaaratERP",
      url: "https://bhaaraterp.com/",
      tag: "Cloud ERP System",
      icon: "🏢",
      desc: "Cloud-based enterprise resource planning platform covering HR, payroll, attendance, inventory and business analytics — deployed on AWS with professional corporate landing page.",
      highlights: [
        "Tech: Django + DRF + PostgreSQL RDS + Nginx/Gunicorn + AWS EC2",
        "Enhancement: Automated payroll-attendance sync → reduced payroll processing time by 70%",
        "Enhancement: Real-time inventory tracking → lowered carrying costs by ~20%",
        "Enhancement: Self-service employee portal → cut HR ticket volume by 50%",
      ],
      stack: ["Python", "Django", "Django REST Framework", "PostgreSQL", "AWS EC2", "AWS RDS", "Nginx"],
    },
    {
      id: "crazzy",
      name: "CrazzyHub",
      url: "https://www.crazzyhub.com/",
      tag: "Full Stack Service Platform",
      icon: "🌐",
      desc: "Full-stack web platform for service listing, provider discovery and user management — featuring a Django REST backend, responsive frontend and a fully featured admin panel.",
      highlights: [
        "Tech: Django REST Framework + MySQL + HTML5/CSS3/JS + custom Django admin",
        "Enhancement: Optimized MySQL search queries → reduced service discovery latency by 55%",
        "Enhancement: Added dynamic service filtering → improved user engagement by 35%",
        "Enhancement: Custom admin panel → reduced content moderation time by 60%",
      ],
      stack: ["Python", "Django", "Django REST Framework", "MySQL", "HTML5", "CSS3", "JavaScript"],
    },
    {
      id: "hudu",
      name: "HUDU",
      url: "https://play.google.com/store/apps/details?id=com.hudu.rudra&hl=en_IN",
      tag: "Android + Django",
      icon: "📱",
      desc: "Mobile-first service and data management app with a Django REST backend powering an Android client — built for real-time operations with secure cloud-hosted APIs.",
      highlights: [
        "Tech: Django REST Framework + JWT auth + Android (Java/Retrofit) + AWS EC2 + MySQL",
        "Enhancement: Mobile-optimized API responses → reduced mobile data usage by 40%",
        "Enhancement: JWT token refresh with auto-renewal → eliminated 95% of session expiry interruptions",
        "Enhancement: Automated MySQL backups on AWS → reduced potential data loss RPO to 15 minutes",
      ],
      stack: ["Python", "Django", "Django REST Framework", "JWT", "Java", "Android", "MySQL", "AWS EC2"],
    },
  ],
};

export const AI_FEATURES = [
  {
    id: "persona_chat",
    label: "Ask Me Anything",
    short: "Chatbot",
    desc: "Have a real conversation with my AI twin. Trained on my projects, skills and experience.",
    placeholder: "e.g. What kind of AI projects has Shivmurat shipped to production?",
    cta: "Start chat",
    accent: "lime",
  },
  {
    id: "project_recommender",
    label: "Project Recommender",
    short: "For recruiters",
    desc: "Describe your role or problem — I'll surface the projects in this portfolio that match best.",
    placeholder: "e.g. We're hiring a backend engineer to build a real-time inference API on AWS.",
    cta: "Recommend projects",
    accent: "amber",
  },
  {
    id: "cover_letter",
    label: "Cover Letter Generator",
    short: "Tailored intro",
    desc: "Paste a job description — I'll draft a tailored intro from Shivmurat's experience.",
    placeholder: "Paste a JD or describe the role you're hiring for…",
    cta: "Draft letter",
    accent: "rose",
  },
  {
    id: "resume_qa",
    label: "Ask My Resume",
    short: "Q&A",
    desc: "Ask anything about my CV — experience, stack, certifications — and get a sourced answer.",
    placeholder: "e.g. What cloud tools has Shivmurat used in production?",
    cta: "Ask resume",
    accent: "sky",
  },
];